// extracted by mini-css-extract-plugin
export var adjacentSlide = "_pr-9";
export var arrowButtonContainer = "_pr-5";
export var arrowButtonIcon = "_pr-6";
export var carouselArrowButton = "_pr-2";
export var carouselElementContainer = "_pr-1";
export var currentSlide = "_pr-8";
export var left = "_pr-3";
export var otherSlide = "_pr-a";
export var productCarouselContainer = "_pr-0";
export var right = "_pr-4";
export var sliderOverflow = "_pr-7";